import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import {
  createTemplate,
  deleteTemplate,
  listTemplates,
  updateTemplate,
  type MessageTemplateInput,
} from '@/api/messages'

/** Every template across both channels — the admin list on the settings page. */
export function useAllTemplates() {
  // Same key as useTemplates(undefined) in features/messaging so the cache is shared.
  return useQuery({ queryKey: ['templates', 'all'], queryFn: () => listTemplates() })
}

// Mutations invalidate the whole ['templates'] prefix so every channel-filtered
// list (send dialogs, workflows) refreshes along with the settings list.

export function useCreateTemplate() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (input: MessageTemplateInput) => createTemplate(input),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['templates'] }),
  })
}

export function useUpdateTemplate() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ id, input }: { id: string; input: MessageTemplateInput }) =>
      updateTemplate(id, input),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['templates'] }),
  })
}

export function useDeleteTemplate() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => deleteTemplate(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['templates'] }),
  })
}
